<template>
  <el-container class="container" v-if="user.username">
    <el-aside class="no-print">
      <div class="logo">
        训<span v-show="!isMenuCollapse">练管理系统</span>
      </div>
      <side-nav :user="user" :isCollapse="isMenuCollapse" :style="{ height: (bodyHeight-51) + 'px' }"/>
    </el-aside>
    <el-container>
      <el-header class="header no-print">
        <top-nav :user="user" @toggle="toggleSideNav"/>
      </el-header>
      <el-main class="main">
        <router-view :user="user" :table-height="tableHeight"/>
      </el-main>
      <el-footer class="footer no-print">&copy;2019-2025 jiaxiao.fun</el-footer>
    </el-container>
  </el-container>
</template>

<script>
import SideNav from './SideNav.vue'
import TopNav from './TopNav.vue'
export default {
  components: {
    SideNav,
    TopNav
  },
  data () {
    return {
      user: {},
      isMenuCollapse: false,
      bodyHeight: 630,
      tableHeight: 470
    }
  },
  beforeMount () {
    const handler = () => {
      this.bodyHeight = window.innerHeight
      this.tableHeight = this.bodyHeight > 560 ? this.bodyHeight - 260 : 300
    }
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    document.addEventListener('visibilitychange', handler)
  },
  created () {
    this.$http.get('/auth/info').then(response => {
      if (response.data.success) {
        this.user = response.data.user
        if (this.user.expiry_date && parseInt((new Date(this.user.expiry_date).getTime() - Date.now())/1000/3600/24) <= -1) {
          this.$router.replace('/expiry')
        } 
        // else if (this.user.group_id == 5 || this.user.group_id == 22) {
        //   this.$router.replace('/expiry')
        // }
      } else {
        this.$router.replace('/login')
      }
    })
  },
  methods: {
    toggleSideNav () {
      this.isMenuCollapse = !this.isMenuCollapse
    }
  }
}
</script>

<style>
.container {
  min-height: 100vh;
  background: #2a3f54;
}
.header {
  background: #ededed;
  border-bottom: 1px solid #d9dee4;
  height: 50px !important;
  line-height: 50px;
}
.el-aside {
  width: auto !important;
  overflow: visible;
}
.logo {
  height: 50px;
  padding-left: 20px;
  color: #fff;
  background-color: #409EFF;
  line-height: 50px;
  font-size: 18px;
  font-weight: 500;
  border-bottom: 1px solid #0e141b;
}
.main {
  background: #F7F7F7;
  padding-top: 10px;
  padding: 10px;
}
.main-title {
  font-size: 20px;
  font-weight: 500;
  color: #73879C;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main-content {
  background: #fff;
  border: 1px solid #D9DEE4;
  padding: 10px;
}
.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-bar .el-form-item {
  margin-bottom: 0 !important;
}
.batch-buttons {
  font-size: 14px;
  margin-bottom: 10px;
}
.el-table td,.el-table th {
  padding: 4px 0 !important;
}
.el-table .el-button--text {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-left: 0 !important;
}
.row-green {
  color: #008B00;
}
.row-blue {
  color: #080046;
}
.row-red {
  color: #ff0000;
}
.row-yellow {
  color: #ba7000;
}
.row-bg-green td {
  color: #fff;
  background-color: #008B00 !important;
}
.row-bg-blue td {
  color: #fff;
  background-color: #04087e !important;
}
.row-bg-red td {
  color: #fff;
  background-color: #f62222 !important;
}
.row-bg-yellow td {
  background-color: #f4f807 !important;
}
.el-pagination {
  margin-top: 10px;
}
.footer {
  background: #fff;
  height: 30px !important;
  border: 1px solid #D9DEE4;
  font-size: 12px;
  line-height: 30px;
  color: #999;
  text-align: right;
}
.el-table .cell {
  word-break: normal;
  white-space: nowrap;
}
.el-table .el-dropdown {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-left: 10px;
}
.el-table .el-dropdown-link {
  color: #409EFF;
  font-weight: 500;
}
.el-table .el-icon--right {
  margin-left: 0;
}
.el-date-editor--daterange.el-input__inner {
  width: 260px;
}
.el-date-editor .el-range-input {
  width: 35%;
}
.search-checkbox.el-checkbox+.el-checkbox {
  margin-left: 4px !important;
}
.search-checkbox .el-checkbox__label {
  padding-left: 2px !important;
}
.el-form-item--small .el-checkbox__label {
  padding-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue